import { PORTAL_API_BASE_URL } from '../../../../constants';
import request from '../../../../util/APIUtils';
import { SEARCH_DEFAULT_LIMIT } from '../constants/lms-course-review.constants';
import { buildSearchQueryParams, toResourceOptions } from '../utils';

const BASE = `${PORTAL_API_BASE_URL}/api/admin/lms-resource-catalog`;

const req = (opts) => request({ ...opts, throw400Error: true });

export const searchResources = async (searchTerm, limit = SEARCH_DEFAULT_LIMIT) => {
  const trimmed = (searchTerm || '').trim();
  if (!trimmed) {
    return [];
  }

  const qs = buildSearchQueryParams(trimmed, limit);
  const response = await req({
    url: `${BASE}/search-resources?${qs.toString()}`,
    method: 'GET',
  });
  return toResourceOptions(response);
};
